'use client';
/**
 * В случае Google-аналитики нам не важно, загрузился скрипт или нет.
 * Мы уже имеем возможность добавлять события в очередь.
 * После загрузки скрипта аналитики, добавленные в очередь события будут обработаны.
 * */ var isScriptLoaded = function() {
    return true;
};

export { isScriptLoaded };
